module.exports = __webpack_public_path__ + "img/20200508_173542.81e9c59b.jpg";